import { ChangeDetectionStrategy, Component, OnInit, TransferState, Type, inject } from '@angular/core';
import { Observable, filter, from, switchMap } from 'rxjs';

import { DISPLAY_VERSION } from 'ish-core/configurations/state-keys';
import { FeatureToggleService } from 'ish-core/feature-toggle.module';

/**
 * Footer Component
 */
@Component({
  selector: 'ish-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent implements OnInit {
  appVersion: string;
  private transferState = inject(TransferState);
  private featureToggleService = inject(FeatureToggleService);
  lazyFooterComponent$: Observable<Type<unknown>> = this.featureToggleService.enabled$('dotCmsUve').pipe(
    filter(enabled => !!enabled),
    switchMap(() =>
      from(
        import('src/app/extensions/dot-cms-uve/shared/dot-cms-uve-footer/dot-cms-uve-footer.component').then(
          m => m.DotCmsUveFooterComponent
        )
      )
    )
  );

  ngOnInit() {
    if (!SSR) {
      this.appVersion = this.transferState.get(DISPLAY_VERSION, '');
    }
  }
}
